import React, { useEffect } from 'react';
import RightSlider from 'component/hoc/rightSlider/RightSlider';
import { FormikProvider, useFormik } from 'formik';
import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';
import * as Yup from 'yup';
import toast from 'react-hot-toast';
import { isEqual } from 'lodash';
import SendEmailForm from 'component/organism/workflow/forms/send-email-form/SendEmailForm';
const SendEmailModal = ({ isOpen, onClose, title, id, isError }) => {
  const {
    workflowData,
    setWorkflowData,
    selectedNode,
    setIsChanged,
    initialWorkflowData,
    isChanged,
  } = useWorkflowContext();

  const formik = useFormik({
    initialValues: {
      emailTo: selectedNode?.email?.emailTo || '',
      subject: selectedNode?.email?.subject || '',
      body: selectedNode?.email?.body || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      emailTo: Yup.string().required('Required'),
      subject: Yup.string().required('Required'),
      body: Yup.string().required('Required'),
    }),
    onSubmit: (values, { resetForm }) => {
      const initialNode = initialWorkflowData?.find((node) => node?.id === id);
      if (initialNode) {
        const { body, emailTo, subject } = initialNode?.email || {};
        const initialMessageObject = {
          body: body || '',
          emailTo: emailTo || '',
          subject: subject || '',
        };
        const currentValues = values;
        const changed = !isEqual(currentValues, initialMessageObject);

        setIsChanged((prev) => {
          const alreadyExists = prev?.includes(id);
          if (changed && !alreadyExists) {
            return [...prev, id];
          }
          if (!changed && alreadyExists) {
            return prev?.filter((nodeId) => nodeId !== id);
          }

          return prev;
        });
      }
    },
  });

  const handleSubmit = async () => {
    await formik.handleSubmit();
    try {
      setTimeout(() => {
        const updatedNodes = workflowData?.nodes?.map((node) =>
          node.id === id
            ? {
                ...node,
                email: formik.values,
                is_Error: isError,
              }
            : node
        );
        setWorkflowData((prev) => {
          return {
            ...prev,
            nodes: updatedNodes,
          };
        });
        onClose();
        formik.resetForm();
      }, [100]);
    } catch {
      toast.error('Something went wrong');
    }
  };

  useEffect(() => {
    const updatedNodes = workflowData?.nodes?.map((node) =>
      node.id === id ? { ...node, is_Error: isError } : node
    );

    setWorkflowData((prev) => ({
      ...prev,
      nodes: updatedNodes,
    }));
  }, [isError]);

  useEffect(() => {
    if (isError) {
      formik.handleSubmit();
    }
  }, [isOpen]);

  return (
    <RightSlider
      title={title}
      action={{
        isOpen: isOpen,
        setIsOpen: handleSubmit,
      }}
    >
      <FormikProvider value={formik}>
        <SendEmailForm id={id} />
      </FormikProvider>
    </RightSlider>
  );
};

export default SendEmailModal;
